/* Signal store behaviour — additive, self-contained; never touches Shrine's commerce elements. */
(function () {
  'use strict';
  document.documentElement.classList.add('sig-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Buy links: on a product page, scroll to the buy box instead of reloading. */
  function buyBox() {
    return document.querySelector('[id^="ProductInfo-"]') || document.querySelector('product-info') || document.querySelector('[id^="MainProduct-"]');
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-sig-buy]');
    if (!a) return;
    var box = buyBox();
    if (!box) return;
    e.preventDefault();
    var top = box.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
  });

  /* Rails: arrow buttons that wrap around at either end (continuous browsing). */
  function initRail(rail) {
    var track = rail.querySelector('[data-sig-rail-track]');
    if (!track || rail.dataset.ready) return;
    rail.dataset.ready = '1';
    function step() {
      var item = track.firstElementChild;
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function go(dir) {
      var max = track.scrollWidth - track.clientWidth - 2;
      var left = track.scrollLeft;
      var behavior = reduce ? 'auto' : 'smooth';
      if (dir > 0 && left >= max) return track.scrollTo({ left: 0, behavior: behavior });
      if (dir < 0 && left <= 2) return track.scrollTo({ left: track.scrollWidth, behavior: behavior });
      track.scrollBy({ left: dir * step(), behavior: behavior });
    }
    var prev = rail.querySelector('[data-sig-prev]');
    var next = rail.querySelector('[data-sig-next]');
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
  }

  /* Rotating words (gift section). */
  function initRotate(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var words = el.querySelectorAll('.sig-gift__word');
    if (words.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      words[i].classList.remove('is-on');
      words[i].classList.add('is-off');
      var prev = words[i];
      setTimeout(function () { prev.classList.remove('is-off'); }, 600);
      i = (i + 1) % words.length;
      words[i].classList.add('is-on');
      words.forEach(function (w, j) { if (j === i) w.removeAttribute('aria-hidden'); else w.setAttribute('aria-hidden', 'true'); });
    }, 2600);
  }

  /* Anatomy: hotspots <-> parts list, and Parts / How to use tabs. */
  function initAnatomy(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    function setPart(idx) {
      root.querySelectorAll('.sig-hotspot').forEach(function (h) { var on = h.dataset.sigHot === idx; h.classList.toggle('is-active', on); h.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      root.querySelectorAll('.sig-part').forEach(function (p) { p.classList.toggle('is-active', p.dataset.sigPart === idx); });
    }
    root.addEventListener('click', function (e) {
      var hot = e.target.closest('[data-sig-hot]');
      if (hot) {
        setPart(hot.dataset.sigHot);
        if (hot.classList.contains('sig-hotspot')) showTab('parts');
      }
      var tab = e.target.closest('[data-sig-tab]');
      if (tab) showTab(tab.dataset.sigTab);
    });
    root.addEventListener('keydown', function (e) {
      var tab = e.target.closest('[data-sig-tab]');
      if (!tab || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight')) return;
      var next = tab.dataset.sigTab === 'parts' ? 'use' : 'parts';
      showTab(next);
      var b = root.querySelector('[data-sig-tab="' + next + '"]'); if (b) b.focus();
    });
    function showTab(name) {
      root.querySelectorAll('[data-sig-tab]').forEach(function (t) {
        var on = t.dataset.sigTab === name;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
      });
      root.classList.toggle('is-use', name === 'use');
    }
  }

  /* Reveal-on-view for the departure board and wave art. */
  function initReveal() {
    var els = document.querySelectorAll('[data-sig-board], .sig-art--heads');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 5000);
  }

  function init() {
    document.querySelectorAll('[data-sig-rail]').forEach(initRail);
    document.querySelectorAll('[data-sig-rotate]').forEach(initRotate);
    document.querySelectorAll('[data-sig-anatomy]').forEach(initAnatomy);
    initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
